export default __webpack_public_path__ + "static/media/refresh-cw.719af04c.svg";